import { fetchGet } from '../fetch';
const convertToCoordinatesBase = (words, format, signal) => {
    const requestOptions = { words };
    if (format !== undefined) {
        requestOptions['format'] = format;
    }
    return fetchGet('convert-to-coordinates', requestOptions, signal);
};
export const convertToCoordinates = (words, signal) => convertToCoordinatesBase(words, 'json', signal);
export const convertToCoordinatesGeoJson = (words, signal) => convertToCoordinatesBase(words, 'geojson', signal);
//# sourceMappingURL=convert-to-coordinates.js.map